export enum EFeatureFlags {
  FastrAppFamilyEnabled = "FASTRAppFamilyEnabled",
}
